import { OktaAuthConfig } from "./types";

const config = window.OKTA_CONFIG.preferences;
const {
  VITE_OKTA_ISSUER,
  VITE_OKTA_PREFERENCES_CLIENT_ID,
  VITE_OKTA_PREFERENCES_REDIRECT_URI,
} = import.meta.env;
export const preferencesAuthConfig: OktaAuthConfig = {
  clientId: VITE_OKTA_PREFERENCES_CLIENT_ID || config.clientId,
  issuer: VITE_OKTA_ISSUER || config.issuer,
  redirectUri: VITE_OKTA_PREFERENCES_REDIRECT_URI || config.redirectUri,
};
